export enum Global {
    PRIVATE = 'private',
    FLEET = 'fleet',
    LEASING = 'leasing',
    FLOTTE_SPECIALIZATION = 'flotte vendita',
    PRINT_URL_CONST = 'print',
    NO_ADVANCE = '0-0',
    ADVANCE = '1-999999',
    EURO = ' €',
    EQUAL = '=',
    QUESTION_MARK = '?',
    PERCENTAGE = '%',
    PREVIEW_DATE = 'preview_date',
    COMMA = ',',
    AND = '&',
    STRING_SEPARATOR = ' - ',
    BUTTON = 'BUTTON',
    LINK = 'LINK',
    ZERO = 0,
    ONE = 1,
    THREE = 3,
    FOUR = 4,
}

export const TODAY = new Date().toISOString().substring(0, 10)

export const FILTERS_KEYS = {
    monthlyRange: 'monthlyRange',
    advance: 'advance',
    totKm: 'totKm',
    period: 'period',
    model: 'models',
    fuel: 'fuels',
}

export const FILTERS_TITLES = {
    monthlyRange: 'Canone mensile',
    advance: 'Anticipo',
    totKm: 'Km totali',
    period: 'Durata',
    model: 'Modello',
    fuel: 'Alimentazione',
}

export const QUERY_PARAMS = {
    monthlyRange: 'rataMensile',
    advance: 'anticipo',
    totKm: 'kmTotali',
    period: 'durata',
    model: 'nomeModello',
    fuel: 'alimentazione',
}

export const ROUTE_PATHS = {
    dealerForm: '/dealer-form',
}
